import { getEntry, getNotSetValue } from 'conversations-async-data/indexed-async-data/operators/getters';
import { createSelector } from 'reselect';
import { getIndexedAsyncMoveStatuses } from './getIndexedAsyncMoveStatuses';
import { COMPOSITION_THREAD_ID } from '../../../communicator/constants/compositionThreadId';
const getThreadIdFromProps = (__state, {
  threadId
}) => threadId;
export const getAsyncMoveStatus = createSelector([getThreadIdFromProps, getIndexedAsyncMoveStatuses], (threadId, indexedAsyncMoveStatuses) => threadId && threadId !== COMPOSITION_THREAD_ID ? getEntry(threadId, indexedAsyncMoveStatuses) : getNotSetValue(indexedAsyncMoveStatuses));